// src/utils/contactHelpers.js

export const sendWhatsAppMessage = (message) => {
  const businessPhone = process.env.REACT_APP_BUSINESS_PHONE || "27681247577";
  const encodedMessage = encodeURIComponent(message);
  const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);
  let url = `https://wa.me/${businessPhone}?text=${encodedMessage}`;
  if (!isMobile) {
    url = `https://web.whatsapp.com/send?phone=${businessPhone}&text=${encodedMessage}`;
  }
  window.open(url, "_blank");
};

export const sendEmailMessage = (message, provider = "gmail") => {
  const businessEmail = process.env.REACT_APP_BUSINESS_EMAIL || "secretariatebusiness@gmail.com";
  const subject = encodeURIComponent("Rental Inquiry - Makozz Motors");
  const body = encodeURIComponent(message);
  const urls = {
    gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${businessEmail}&su=${subject}&body=${body}`,
    outlook: `https://outlook.live.com/mail/0/deeplink/compose?to=${businessEmail}&subject=${subject}&body=${body}`,
    yahoo: `https://mail.yahoo.com/d/compose?to=${businessEmail}&subject=${subject}&body=${body}`,
  };
  window.open(urls[provider] || `mailto:${businessEmail}?subject=${subject}&body=${body}`, "_blank");
};